import { Store } from '../../../helpers';
import { loaded, loading } from '../../../layout/redux/layoutActions';
import { cleanMapActions } from '../../dashboard/mapControls/controllers/actionsMap.controllers';
import Map from 'eemovel-map-library/src/data/google-maps/map';
import { ICity } from '../types/mapSearch.types';

export const changeCity = (newCity: ICity) => {
  Store.dispatch(loading());
  cleanMapActions();
  Map.map.setCenter({
    lat: newCity.coordinates.latitude,
    lng: newCity.coordinates.longitude,
  });
  Map.map.setZoom(12);
  Store.dispatch(loaded());
};

export const boundBoxToLatLngBounds = (
  boundBox: [number[], number[]]
): google.maps.LatLngBoundsLiteral => {
  const [[east, north], [west, south]] = boundBox;
  return {
    north,
    east,
    south,
    west,
  };
};

export const initialCity = ({
  cities,
  defaultCity,
}: {
  cities: ICity[];
  defaultCity?: ICity;
}) => {
  const savedDefaultCity = JSON.parse(
    sessionStorage.getItem('defaultCity') || '{}'
  );

  const hasSaoPaulo = cities.find(
    ({ elastic_city_id }) => elastic_city_id === '5270'
  );

  const hasSavedDefaultCity = cities.find(
    ({ elastic_city_id }) =>
      elastic_city_id === savedDefaultCity?.elastic_city_id
  );

  if (defaultCity) return defaultCity;
  if (hasSavedDefaultCity) return hasSavedDefaultCity;
  if (hasSaoPaulo) return hasSaoPaulo;

  return cities[0];
};
